// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__hVcTc","name":"ConsentHeader_name__xWFrN","birthday":"ConsentHeader_birthday__XXNpI","skeleton":"ConsentHeader_skeleton__1I9rG"};